import { Button } from "@/components/ui/button";

type AppErrorFallbackProps = {
	onRetry?: () => void;
};

export default function AppErrorFallback({ onRetry }: AppErrorFallbackProps) {
	return (
		<div className="flex min-h-screen items-center justify-center px-6">
			<div className="w-full max-w-lg rounded-2xl border border-slate-200 bg-white p-8 text-center shadow-card">
				<p className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">Error</p>
				<h1 className="mt-3 font-['Fraunces'] text-3xl font-bold text-ink">Something went wrong</h1>
				<p className="mt-3 text-sm leading-7 text-slate-600">
					An unexpected error occurred. We have been notified and are working on a fix.
				</p>
				<div className="mt-6 flex justify-center gap-2">
					<Button type="button" variant="outline" onClick={() => window.location.assign("/")}>
						Go to home
					</Button>
					<Button type="button" onClick={onRetry}>
						Try again
					</Button>
				</div>
			</div>
		</div>
	);
}
